import Vue from "vue";
import VueI18n from "vue-i18n";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const router = (i18n: VueI18n) =>
  new VueRouter({
    mode: "hash",
    routes: [
      {
        path: "/:lang",
        name: "main",
        beforeEnter(to, from, next) {
          const lang = to.params.lang;
          if (lang) {
            i18n.locale = lang.toLowerCase();
          }
          next();
        }
      }
    ]
  });

export default router;
